import { useNavigate } from 'react-router-dom';

import './section-list.scss';

import { routerKeys } from '~shared/router';
import { Preloader } from '~shared/ui';

import { SectionItem } from './SectionItem/SectionItem';
import { useLoadSections } from './use-load-sections';

export function SectionList() {
	const { list, isPending, changeAllAllowed } = useLoadSections();
	const navigate = useNavigate();

	const handleEdit = (id: number) => {
		navigate(routerKeys.cabinet.admin.sections.section(id.toString()));
	};

	const handleChangeAllAllowed = (id: number, value: boolean) => {
		changeAllAllowed(id, value);
	};

	return (
		<div className="section-list">
			<div className="table-overlay">
				<table className="table">
					<thead>
						<tr>
							<th>Участок</th>
							<th>Доступно всем</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						{isPending ? (
							<tr>
								<td colSpan={2} align="center">
									<Preloader />
								</td>
							</tr>
						) : (
							<>
								{list.map(itm => (
									<SectionItem
										key={itm.id}
										section={itm}
										onEdit={handleEdit}
										onChangeAllAllowed={handleChangeAllAllowed}
									/>
								))}
							</>
						)}
					</tbody>
				</table>
			</div>
		</div>
	);
}
